/// <amd-module name="Test/TestPlansHubRefresh/Pivots/AuthorPivot/AuthorConstants" />
export const TestCaseWorkItemType = "Test Case";
export const TestCaseCreationMode = 1;
export const AuthorTabZeroDataImagePath = "ms.vss-test-web/testplan-hub-refresh-assets/zero-data-author-tab.png";
export const AuthorPivotName = "Define";
export const AssignConfigToTestCasesDialog = "AssignConfigToTestCases";
export const DragTestCasesText = " test cases";
export const OrderColumn = "order";
export const AssignedToColumn = "assignedTo";
export const NameColumn = "name";
export const StateColumn = "state";
export const TestCaseIdColumn = "id";
export const WorkItemId = "System.Id";
export const WorkItemCreatedDate = "System.CreatedDate";
export const WorkItemChangedDate = "System.ChangedDate";
export const contributionId = "ms.vss-test-web.testplans-hub-refresh-route";
export const queryParams = "?planId={0}&suiteId={1}";
export const TOAST_MESSAGE_DURATION = 5000;
export const WorkItemTypeCategoryTestCase = "Microsoft.TestCaseCategory"
